import { render, staticRenderFns } from "./BatchNotificationHouseUserForm.vue?vue&type=template&id=0bef9544"
import script from "./BatchNotificationHouseUserForm.vue?vue&type=script&lang=js"
export * from "./BatchNotificationHouseUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports